<template>
	<div class="full-width">
		<div class="row q-my-sm">
			<div style="flex: 1">
				<q-btn icon="fal fa-chevron-left" flat round dense @click="backButton()" />
			</div>

			<div class="text-h5 text-weight-bold">
				{{ $t(title) }}
			</div>

			<div style="flex: 1"></div>
		</div>

		<client-logo />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ClientLogo from 'components/utils/ClientLogo'

export default {
	name: 'CardHeader',

	props: ['title'],

	components: {
		'client-logo': ClientLogo,
	},

	computed: {
		...mapGetters({
			use_portfolio_page: 'params/use_portfolio_page',
		}),
	},

	methods: {
		backButton() {
			if (!this.use_portfolio_page) this.$router.push({ name: 'login' })
			else this.$router.push({ name: 'portfolio' })
		},
	},
}
</script>

<style></style>
